import Paper from '@material-ui/core/Paper';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import React from 'react';
import Grow from '@material-ui/core/Grow';
import { storeItem, getValueFromSessionStored } from "./Session";

import Maximized from './Maximized';
import Minimized from './Minimized';
const defaultStyles = require('./styles/default.json')
export const defaultTheme = createTheme(defaultStyles)

const styles = () => ({
  paper: {
    zIndex: "100000",
    position: "fixed",
    bottom: "60px",
    right: "15px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "calc(100vh - 60px)",
    height: "1000px",
    width: "400px",
    transition: "all 100ms ease-out 0s",
    transform: "none",
    "@media (max-width: 490px)": {
      width: "100%",
      bottom: "130px",
      right: "0em",
      height: "100%",
      maxHeight: "calc(100vh - 130px)"
    },
    "@media (max-height: 515px)": {
      bottom: "130px",
      right: "0em",
      height: "100%",
      maxHeight: "calc(100vh - 130px)"
    },
  }
})



class Chat extends React.Component {
  constructor(props) {
    super(props);
    //sessionStorage.clear();
    this.state = {
      theme: defaultTheme,
      languages: ["es"],
      selected_language: "es",
      params: {},
      windowState: getValueFromSessionStored("chatbotState", "minimized")
    }
  }

  updateLanguage = (selected) => {
    this.setState({ selected_language: selected })
  }

  minimize = () => {
    this.setState({ windowState: "minimized" })
    storeItem("chatbotState", "minimized")
  }

  maximize = () => {
    this.setState({ windowState: "maximized" })
    storeItem("chatbotState", "maximized")
  }

  render() {
    const { classes } = this.props;
    if (this.state.windowState === "maximized") {
      return (
        <MuiThemeProvider theme={this.state.theme}>
          <Grow in={true} style={{ transformOrigin: 'bottom right' }}>
            <Paper className={classes.paper}>
              <Maximized
                languages={this.state.languages}
                selected_language={this.state.selected_language}
                params={this.state.params}
                updateLanguage={val => this.updateLanguage(val)}
                minimize={this.minimize}
                {...this.props}
              />
            </Paper>
          </Grow>
        </MuiThemeProvider>
      );
    }
    else {
      return (
        <MuiThemeProvider theme={this.state.theme}>
          <Minimized maximize={this.maximize} />
        </MuiThemeProvider>
      )
    }
  }
}

export default withStyles(styles)(Chat);
